import styled from "styled-components";

export const StyledAccountContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const StyledAccountHeader = styled.div`
  display: flex;
  flex-direction: row;
  gap: 6px;
  align-items: center;
  padding: 7px 4px;
`;

export const StyledUsernameContainer = styled.span`
  animation: appear 0.5s ease;

  @keyframes appear {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }
`;

export const StyledAvatarContainer = styled.div`
  width: ${({ size = "18px" }) => size};
  height: ${({ size = "18px" }) => size};

  box-sizing: border-box;
  background: ${({ hasBg }) => (hasBg ? "#eee" : "transparent")};
  border-radius: 100px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #344054;
  user-select: none;
  cursor: pointer;
  font-size: 10px;
`;

export const StyledUserInfoContainer = styled.div`
  display: flex;
  gap: 4px;
  flex-direction: column;

  span:first-child {
    font-size: 12px;
  }

  span:last-child {
    font-size: 10px;
    color: #878787;
  }
`;

export const StyledLoginModalContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  justify-content: center;
  font-size: 15px;
  color: var(--fontColor);
  width: 400px;
`;

export const StyledModalText = styled.div`
  text-align: center;
`;

export const StyledModalButtonContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  justify-content: center;
  margin-top: 20px;
  gap: 30px;
`;
